import { DOCUMENT, inject, Injectable, RendererFactory2, RendererStyleFlags2 } from '@angular/core';

const CLARITY_FLY_IN_INSET_BLOCK_START_PROPERTY = '--eff-clarity-fly-in-inset-block-start';

/**
 * Publishes the lowest bottom edge of the registered elements, in viewport px, as
 * `--eff-clarity-fly-in-inset-block-start` on the document's root element; removes the property when none is left.
 */
@Injectable({ providedIn: 'root' })
export class ClarityFlyInTopEdges {
	private readonly root = inject(DOCUMENT).documentElement;
	private readonly renderer = inject(RendererFactory2).createRenderer(null, null);
	private readonly edges = new Set<HTMLElement>();

	public add(edge: HTMLElement): void {
		this.edges.add(edge);
		this.publish();
	}

	public remove(edge: HTMLElement): void {
		this.edges.delete(edge);
		this.publish();
	}

	/** Measures every mark again and publishes the lowest bottom edge, or removes the property when none is left. */
	public publish(): void {
		if (this.edges.size === 0) {
			this.renderer.removeStyle(
				this.root,
				CLARITY_FLY_IN_INSET_BLOCK_START_PROPERTY,
				RendererStyleFlags2.DashCase,
			);

			return;
		}

		const bottom = Math.max(...Array.from(this.edges, edge => edge.getBoundingClientRect().bottom));

		this.renderer.setStyle(
			this.root,
			CLARITY_FLY_IN_INSET_BLOCK_START_PROPERTY,
			`${bottom}px`,
			RendererStyleFlags2.DashCase,
		);
	}
}
